import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import CtaBand from "@/components/CtaBand";
import { Reveal } from "@/components/Reveal";
import { SERVICES } from "@/data/content";

const ServicesOverview = () => (
  <>
    <SEO
      title="STD & STI Treatment in Delhi | Delhi STD Clinic — Dr. Ankur Lal"
      description="Confidential STD/STI treatment in Delhi — syphilis, genital warts/HPV, HIV PEP & PrEP, gonorrhea, chlamydia, genital herpes, molluscum — by Dr. Ankur Lal, Ex-STD Specialist, AIIMS New Delhi."
      path="/std-sti-treatment"
    />
    <PageHero
      eyebrow="STD / STI Treatment in Delhi"
      title="Specialist STD & STI Care"
      intro="Focused, guideline-based diagnosis and treatment of sexually transmitted infections and sexual-health conditions — confidential, respectful and judgment-free."
    />

    <section className="py-16 sm:py-24" data-testid="services-grid">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        <Reveal>
          <Link
            to="/hiv-pep-delhi"
            data-testid="overview-card-hiv-pep"
            className="group flex flex-col h-full bg-amber-50 border border-amber-300/60 rounded-3xl p-7 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl"
          >
            <span className="inline-flex w-fit items-center gap-1.5 bg-amber-600 text-white text-[10px] font-bold tracking-[0.15em] uppercase px-3 py-1 rounded-full">
              Time-Sensitive
            </span>
            <h2 className="mt-4 font-serif text-2xl font-semibold text-slate-950">HIV PEP</h2>
            <p className="mt-2.5 text-sm text-slate-600 leading-relaxed flex-1">
              Urgent assessment following a potential HIV exposure. PEP should be started
              as soon as possible and is generally not recommended after 72 hours.
            </p>
            <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-amber-800 group-hover:gap-2.5 transition-all">
              Urgent consultation <ArrowUpRight className="w-4 h-4" />
            </span>
          </Link>
        </Reveal>
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug} delay={(i % 3) * 0.06}>
            <Link
              to={`/services/${s.slug}`}
              data-testid={`overview-card-${s.slug}`}
              className="group flex flex-col h-full bg-white border border-slate-900/10 rounded-3xl p-7 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_-20px_rgba(6,78,59,0.25)] hover:border-emerald-900/25"
            >
              <h2 className="font-serif text-2xl font-semibold text-slate-950">{s.name}</h2>
              <p className="mt-2.5 text-sm text-slate-600 leading-relaxed flex-1">{s.gridDesc}</p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-900 group-hover:gap-2.5 transition-all">
                Learn more <ArrowUpRight className="w-4 h-4" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>

      <Reveal className="max-w-7xl mx-auto px-5 sm:px-8 mt-12">
        <div className="bg-emerald-50 border border-emerald-900/15 rounded-3xl p-7 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
          <p className="text-sm text-emerald-950 leading-relaxed max-w-2xl">
            Not sure which concern applies to you? A confidential consultation is the
            right first step — Dr. Ankur Lal will guide assessment, testing and treatment
            based on your individual situation.
          </p>
          <Link
            to="/booking?type=online"
            data-testid="overview-book-cta"
            className="shrink-0 inline-flex items-center gap-2 bg-emerald-900 hover:bg-emerald-800 text-white font-semibold text-sm px-6 py-3 rounded-full transition-all"
          >
            Book a Consultation <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </Reveal>
    </section>

    <CtaBand />
  </>
);

export default ServicesOverview;
